import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdDownloadForOffline } from "react-icons/md";
import { GrAddCircle } from "react-icons/gr";
import {
  GreenLedSolo,
  BlueLedSolo,
  RedLedSolo,
  YellowLedSolo,
} from "../../Team/userCard/Led";
import styles from "./CalibrationArray.module.scss";

const CalibrationArray = ({ cabname, onPressBack, cab, hasCalibData = true }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState({ id: null, type: null });
  const [mobile, setMobile] = useState(false);
  const [displayLed, setDisplayLed] = useState(false);

  const displayGoodColorLed = (number, label) => {
    if (number <= 0 && number !== null)
      return <RedLedSolo label={label} />;
    else if (number <= 30 && number !== null)
      return <YellowLedSolo label={label} />;
    else if (number >= 30 && number !== null)
      return <GreenLedSolo label={label} />;
    else return <BlueLedSolo label={label} />;
  };

  const getBubbleText = (number) => {
    if (number === null || number === undefined) return t("calibration.no_calibration");
    const n = Math.abs(number);
    if (number >= 0) return t("calibration.days_remaining", { n });
    return t("calibration.days_overdue", { n });
  };

  useEffect(() => {
    const handleResize = () => setMobile(window.innerWidth < 950);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showLedRow = !mobile || (mobile && displayLed);

  const LedItem = ({ type, value, label }) => {
    const bubbleOpen = selected.id === cab?.id && selected.type === type;

    const handleDownload = () => {
      // ✅ clic sur CO / Inserts / etc => download
      if (typeof onPressBack === "function") onPressBack();
    };

    return (
      <div
        className={styles.ledItem}
        role="button"
        tabIndex={0}
        title={t("calibration.download_certificate")}
        onClick={handleDownload}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleDownload();
        }}
        // ✅ Bubble uniquement desktop (hover)
        onMouseEnter={() => !mobile && setSelected({ id: cab?.id, type })}
        onMouseLeave={() => !mobile && setSelected({ id: null, type: null })}
      >
        <div className={styles.ledRight}>
          {displayGoodColorLed(value, label)}
        </div>

        {/* Bubble (hover desktop) */}
        {bubbleOpen && (
          <div className={styles.bubble}>
            <div className={styles.bubbleTitle}>{label}</div>
            <div className={styles.bubbleText}>{getBubbleText(value)}</div>
            <div className={styles.bubbleHint}>{t("calibration.click_to_download")}</div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.card}>
      {/* TOP ROW */}
      <div className={styles.topRow}>
        <div className={styles.titleBlock}>
          <h3 className={styles.cabname} title={cabname}>
            {cabname}
          </h3>
          <div className={styles.subInfo}>ID: {cab?.id ?? "—"}</div>
        </div>

        {mobile && (
          <button
            className={`${styles.iconBtn} has-tooltip`}
            type="button"
            onClick={() => setDisplayLed((v) => !v)}
            aria-label={t("calibration.toggle_indicators")}
          >
            <GrAddCircle />
          </button>
        )}

        {hasCalibData && (
          <button
            className={`${styles.downloadBtn} has-tooltip`}
            type="button"
            onClick={onPressBack}
            aria-label={t("calibration.download_cert_btn")}
          >
            <MdDownloadForOffline />
          </button>
        )}
      </div>

      {/* LED ROW */}
      {hasCalibData && showLedRow && (
        <div className={styles.ledRow}>
          <LedItem
            type="co"
            value={cab?.numberDayBone}
            label="CO"
          />
          <LedItem
            type="head"
            value={cab?.numberDayHead}
            label="Casque"
          />
          <LedItem
            type="insert"
            value={cab?.numberDayInsert}
            label="Inserts"
          />
          <LedItem
            type="speakers"
            value={cab?.numberDaySpeakers}
            label="Champ libre"
          />
        </div>
      )}

      {/* CTA compact en bas */}
      <div className={styles.footer}>
        {hasCalibData ? (
          <button className={styles.cta} type="button" onClick={onPressBack}>
            {t("calibration.calibration_certificate")}
          </button>
        ) : (
          <div className={styles.noDataMessage}>
            Aucune données de calibration pour cette cabine
          </div>
        )}
      </div>
    </div>
  );
};

export default CalibrationArray;
